import { ApiClient } from "@modules/core/api/client/apiClient"
import { type PromoCodeApiGateway } from "@modules/promoCode/gateway/promoCodeApi.gateway"
import { type CoachPromoCodeDto } from "@modules/promoCode/gateway/promoCodeDto"
import { type PromoCodeDraft } from "@modules/promoCode/types/promoCodeTypes"

export class PromoCodeApi implements PromoCodeApiGateway {
  private baseUrl = "/promo-codes"

  constructor(private api: ApiClient) {}

  async getPromoCodes(expired: boolean): Promise<CoachPromoCodeDto[]> {
    const result = await this.api.get<CoachPromoCodeDto[]>(`${this.baseUrl}`, { params: { expired } })
    return result.data
  }

  async createPromoCode(promoCodeDraft: PromoCodeDraft) {
    const resultDto = await this.api.post<CoachPromoCodeDto>(`${this.baseUrl}`, promoCodeDraft)

    return resultDto.data
  }

  async updatePromoCode(id: string, promoCodeDraft: PromoCodeDraft) {
    const resultDto = await this.api.put<CoachPromoCodeDto>(`${this.baseUrl}/${id}`, promoCodeDraft)
    return resultDto.data
  }

  async deletePromoCode(id: string) {
    await this.api.delete(`${this.baseUrl}/${id}`)
  }
}
